<template>
  <div class="form-area">
    <div class="form-title">
      請核對個人資料<br>
      Please check the following personal information
    </div>

    <div class="form-header-desc">
      閣下的個人資料<br>Your particular:
    </div>
    <div class="form-desc">
      個人住屋資料</br>
      Housing information
    </div>
    <el-row :gutter="10" class="form-row" v-for="item in houseFields" :key="item.key">
      <el-col :span="8">
        <div class="form-label" v-html="item.label" />
      </el-col>
      <el-col :span="16" class="value-content">

        <!-- 住所類型單選 -->
        <div class="form-value" v-if="item.key=='residenceType'">
          <span v-if="hleFormData.otherResidenceType"> {{hleFormData.otherResidenceType}}</span>
          <span v-else>
            <dict-tag :options="dict.type.residence_types" :value="hleFormData.residenceType" />
          </span>
        </div>
        <!-- 其他表單字段 -->
        <div class="form-value" v-else>
          <div v-if="item.key=='detailAddress'">{{hleFormData.islands.label}} {{hleFormData.areas}}<br><span
              v-html="hleFormData[item.key]" />
          </div>
          <div v-else><span v-html="hleFormData[item.key]" /></div>
        </div>
      </el-col>
    </el-row>
    <div class="form-desc">
      申請人個人生活及工作資料<br />
      Living and employment information
    </div>
    <el-row :gutter="10" class="form-row" v-for="item in livingFields" :key="item.key">
      <el-col :span="8">
        <div class="form-label" v-html="item.label" />
      </el-col>
      <el-col :span="16" class="value-content">
        <!-- 學歷翻譯 -->
        <div class="form-value" v-if="item.key=='education'">
          <dict-tag :options="dict.type.education" :value="hleFormData.education" />
        </div>
        <div v-else class="form-value" v-html="hleFormData[item.key]" />
      </el-col>
    </el-row>


    <div v-if="!isSingle">
      <div class="form-header-desc">
        第⼆位申請⼈的個⼈資料<br>
        Second applicant's particular:
      </div>
      <div class="form-desc">
        個人住屋資料</br>
        Housing information
      </div>
      <el-row :gutter="10" class="form-row" v-for="item in houseFields" :key="item.key">
        <el-col :span="8">
          <div class="form-label" v-html="item.label" />
        </el-col>
        <el-col :span="16" class="value-content">

          <!-- 住所類型單選 -->
          <div class="form-value" v-if="item.key=='residenceType'">
            <span v-if="hleFormData2.otherResidenceType"> {{hleFormData2.otherResidenceType}}</span>
            <span v-else>
              <dict-tag :options="dict.type.residence_types" :value="hleFormData2.residenceType" />
            </span>
          </div>
          <!-- 其他表單字段 -->
          <div class="form-value" v-else>
            <div v-if="item.key=='detailAddress'">{{hleFormData2.islands.label}} {{hleFormData2.areas}}<br><span
                v-html="hleFormData2[item.key]" />
            </div>
            <div v-else><span v-html="hleFormData2[item.key]" /></div>
          </div>
        </el-col>
      </el-row>

      <div class="form-desc">
        申請人個人生活及工作資料<br />
        Living and employment information
      </div>
      <el-row :gutter="8" class="form-row" v-for="item in livingFields" :key="item.key">
        <el-col :span="8">
          <div class="form-label" v-html="item.label" />
        </el-col>
        <el-col :span="16" class="value-content">
          <!-- 學歷翻譯 -->
          <div class="form-value" v-if="item.key=='education'">
            <dict-tag :options="dict.type.education" :value="hleFormData2.education" />
          </div>
          <div v-else class="form-value" v-html="hleFormData2[item.key]" />
        </el-col>
      </el-row>
    </div>
    <div class="btn-box">
      <el-row>
        <el-col :span="12">
          <el-button type="warning" class="two-btn" round @click="previousSetp">上一步 Back</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="warning" class="two-btn" round @click="nextSetp">繼續 Next</el-button>
        </el-col>
      </el-row>
    </div>


  </div>
</template>

<script>
  import {
    filterFormFieldsData
  } from "@/utils/json/utils";
  export default {
    dicts: ["education", "residence_types"],
    data() {
      return {
        isSingle: this.Session.get("formId") === 1, //是否单人申请
        houseFields: filterFormFieldsData("housingInformationFields"), //个人住屋信息
        livingFields: filterFormFieldsData("livingFormFields"), //个人生活信息
        hleFormData: this.Session.get("hleFormData"), //第一位申请人信息
        hleFormData2: this.Session.get("hleFormData2"), //第二位申请人信息
      };
    },

    methods: {
      nextSetp() {
        this.$store.dispatch("NEXT_STEP", {
          changeStep: true,
          operateName: "fileIndex",
        });
      },
      previousSetp() {
        this.$store.dispatch("PREVIOUS_SETP", {
          changeStep: false,
          operateName: "declaration",
        });
      },
    },
  };

</script>

<style>
  .value-content {
    padding-left: 60px !important;
  }

</style>



// WEBPACK FOOTER //
// src/view/apply/child/information.vue